import { Injectable } from '@angular/core';
import { InvoiceData, InvoicePostRequest } from '../models/invoice';
import { CommunicationManagerService } from './communication-manager.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InvoiceService {
  constructor(private cm: CommunicationManagerService) {}

  getInvoicesForProject(versionLink: string) {
    return this.cm.get(`invoice/all/${versionLink}`, []) as Observable<
      InvoiceData[]
    >;
  }
  createInvoiceForProject(
    invoice: InvoicePostRequest,
    projectId: string,
    companyId: string
  ) {
    return this.cm.post('invoice', invoice, [
      { headerName: 'projectId', headerValue: projectId },
      { headerName: 'companyId', headerValue: companyId },
    ]);
  }

  uploadInvoice(invoice: File, invoiceId: string, projectId: string) {
    const payload = new FormData();
    payload.append('file', invoice, invoice.name);

    return this.cm.uploadAndGetJson({
      route: `invoice/attachFile/${invoiceId}`,
      payload: payload,
      addHeaders: [{ headerName: 'projectId', headerValue: projectId }],
    });
  }

  downloadInvoice(invoiceId: string, invoiceFileId: string, projectId: string) {
    return this.cm.downloadFile(
      `invoice/downloadFile/${invoiceId}/${invoiceFileId}`,
      [{ headerName: 'projectId', headerValue: projectId }]
    );
  }

  updateInvoice(invoice: InvoiceData) {
    invoice.status =
      invoice.receivedAmount === 0
        ? 'Sent'
        : invoice.receivedAmount < invoice.invoiceAmount
        ? 'Partial'
        : invoice.receivedAmount === invoice.invoiceAmount
        ? 'Paid'
        : 'Overpaid';

    return this.cm.put(
      `invoice/${invoice._id}`,
      {
        paymentExpectedDate: invoice.paymentExpectedDate,
        payments: invoice.payments,
        status: invoice.status,
      } as InvoiceData,
      [{ headerName: 'projectId', headerValue: invoice.project }]
    ) as Observable<InvoiceData>;
  }
}
